import { useField } from "formik";
import { Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { SimpleFormSelect, SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import SimpleFormTagsInput from "src/app/components/form/SimpleFormTagsInput";
import { SimpleFormTextarea } from "src/app/components/form/SimpleFormTextarea";
import { Content } from "src/app/types/content";
import { handleData, TDocMetrics } from "src/app/utils/textCheckHandler/handleData";
import { CkEditorCustom } from "..";

export interface IViewTextLibraryForm {
    thematicsOptions?: SimpleFormSelectOption[];
    writingTypeOptions?: SimpleFormSelectOption[];
    entity: Content;
    docMetrics?: TDocMetrics;
    setDocMetrics: React.Dispatch<React.SetStateAction<TDocMetrics | undefined>>;
}

const ViewTextLibraryForm = (props: IViewTextLibraryForm) => {
    const { thematicsOptions = [], entity, writingTypeOptions = [], setDocMetrics } = props;
    const [, textMetaProps, textHelperProps] = useField(`text`);
    const { formatMessage } = useIntl();
    return (
        <Row className="ViewTextLibraryFormWrapper">
            <Col sm={2}>
                <SimpleFormSelect
                    name="thematicId"
                    label={formatMessage({ id: "common.field.thematic" })}
                    placeholder={formatMessage({ id: "common.field.thematic" })}
                    values={thematicsOptions}
                />
                <SimpleFormSelect
                    name="writingType"
                    label={formatMessage({ id: "common.field.writingType" })}
                    placeholder={formatMessage({ id: "common.field.writingType" })}
                    values={writingTypeOptions}
                />
                <SimpleFormTagsInput
                    name="keywords"
                    label={formatMessage({
                        id: "common.field.keywords",
                    })}
                    tagPlaceholder={formatMessage({
                        id: "common.field.placeholder.addKeyword",
                    })}
                />
            </Col>
            <Col>
                <SimpleFormControl
                    name="title"
                    label={formatMessage({ id: "common.field.title" })}
                    placeholder={formatMessage({ id: "common.field.title" })}
                />

                <SimpleFormControl
                    placeholder={formatMessage({ id: "common.field.metaTitle" })}
                    name="metaTitle"
                    cssClass={["noGrayBackground"]}
                    maxLength={80}
                />

                <SimpleFormTextarea
                    cssClass={["no-resize"]}
                    placeholder={formatMessage({ id: "common.field.metaDescription" })}
                    rows={2}
                    maxLength={200}
                    name="metaDescription"
                />
                <CkEditorCustom
                    data={textMetaProps.value}
                    onReady={(editor) => {
                        const data = editor.getData();
                        setDocMetrics(handleData(data, entity));
                        textHelperProps.setValue(data);
                    }}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        setDocMetrics(handleData(data, entity));
                        textHelperProps.setValue(data);
                    }}
                />
            </Col>
        </Row>
    );
};

export default ViewTextLibraryForm;
